import cn from 'clsx'

// Components
import { Button, Link, IconCreditAlt } from '@tracklib/kit'

// Hooks
import { useSubscription } from 'modules/subscription/hooks'
import { useProfile } from 'modules/profile/hooks'
import { useTracking } from 'modules/tracking/hooks'

import styles from './credits.css'

type CreditsProps = {
  expanded?: boolean
  compressed?: boolean
  hideOnMobile?: boolean
  className?: string
}

const Credits = ({ hideOnMobile, expanded, compressed, className }: CreditsProps): JSX.Element | null => {
  const subscription = useSubscription()
  const profile = useProfile()
  const trackEvent = useTracking()

  if (!profile) {
    return null
  }

  const canSpendCredits = ['TRIAL', 'ACTIVE', 'CANCELLED'].includes(subscription?.state)
  if (!canSpendCredits) {
    return (
      <div className={cn(className, expanded && styles.noSubscriberExpanded)}>
        {expanded && (
          <>
            <p className={styles.title}>You’re using a free version</p>
            <p className={styles.body}>In order to download tracks and loops, you need to upgrade to a paid plan.</p>
          </>
        )}
        {profile.id !== 0 && (
          <Button
            to="/subscribe/"
            datatesting="button_upgrade_account"
            className={cn(styles.upgradeButton, !expanded && styles.hideOnMobile)}
            onClick={() => trackEvent('Clicked "upgrade" in nav"')}
          >
            Upgrade account
          </Button>
        )}
      </div>
    )
  }

  const creditCount = subscription?.credit_count
  return (
    <div className={cn(hideOnMobile && styles.hideOnMobile)}>
      <Link
        to="credits"
        modal
        className={cn(expanded ? styles.wrapperExpanded : styles.wrapper, compressed && styles.compressed, className)}
        datatesting="button_open_credits_modal"
      >
        <IconCreditAlt className={expanded ? styles.coinBig : styles.coin} />
        <span datatesting="header_creditcount">
          {creditCount}{' '}
          <span className={expanded ? styles.labelExpanded : styles.label}>Credit{creditCount > 1 || creditCount === 0 ? 's' : ''}</span>
          {expanded && <p className={styles.plan}>{subscription?.tier?.label}</p>}
        </span>
      </Link>
    </div>
  )
}

export default Credits
